var _path, _circle, _circle2, _path2, _path3, _circle3, _circle4, _circle5, _circle6, _circle7, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCefta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-cefta",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M0 0h640v480H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 249.8,
    r: 30.4,
    fill: "none",
    stroke: "#fc0",
    strokeWidth: 27.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 249.8,
    r: 88.3,
    fill: "none",
    stroke: "#fc0",
    strokeWidth: 27.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "m404.7 165.1 84.7 84.7-84.7 84.7-84.7-84.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M175.7 236.1h59.2v27.5h-59.2zM434.8 236.1h88.3v27.5h-88.3zM363 187.4l38.8-38.8 19.4 19.5-38.7 38.7zM306.3 48.6h27.5v107.1h-27.5z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.1,
    cy: 159.6,
    r: 13.7,
    fill: "#fc0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.3,
    cy: 249.8,
    r: 13.7,
    fill: "#fc0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 381.4,
    r: 13.7,
    fill: "#fc0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 425.5,
    r: 13.7,
    fill: "#fc0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 408.3,
    cy: 249.8,
    r: 13.7,
    fill: "#fc0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m208.3 341.5 19.5-19.4 19.4 19.4-19.4 19.5zM413 362.5l19.5-19.5 19.5 19.5-19.5 19.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCefta);
export default __webpack_public_path__ + "static/media/cefta.c30b5601.svg";
export { ForwardRef as ReactComponent };